module.exports = __webpack_public_path__ + "img/me.e8b77067.jpeg";